import React from 'react';
import {
  Box,
  Flex,
  Text,
  IconButton,
  HStack,
  Icon,
  Tag,
  Menu,
  MenuButton,
  MenuList,
  MenuItem,
  Button
} from '@chakra-ui/react';
import { FiX, FiBook, FiGrid, FiAlertCircle, FiChevronDown } from 'react-icons/fi';

const ModalHeader = ({ task, onClose }) => {
  const getTypeConfig = (type) => {
    switch (type?.toLowerCase()) {
      case 'story':
        return { icon: FiBook, bg: '#36B37E', label: 'Story' };
      case 'task':
        return { icon: FiGrid, bg: '#0065FF', label: 'Task' };
      case 'bug':
        return { icon: FiAlertCircle, bg: '#FF5630', label: 'Bug' };
      default:
        return { icon: FiGrid, bg: '#6B778C', label: 'Task' };
    }
  };

  const typeConfig = getTypeConfig(task?.type);

  return (
    <Box bg="#F4F5F7" px={6} py={4} borderBottom="1px solid #DFE1E6">
      <Flex justify="space-between" align="center">

        {/* LEFT: Task Type + Title */}
        <HStack spacing={3}>
          <Tag
            size="sm"
            bg={typeConfig.bg}
            color="white"
            borderRadius="md"
            px={2}
            py={1}
            fontWeight="600"
          >
            <HStack spacing={1}>
              <Icon as={typeConfig.icon} boxSize={3.5} />
              <Text fontSize="12px">{typeConfig.label}</Text>
            </HStack>
          </Tag>
          <Text fontSize="16px" fontWeight="600" color="#172B4D">
            {task?.title || 'Untitled Task'}
          </Text>
        </HStack>

        {/* RIGHT: Dropdown + Close */}
        <HStack spacing={2}>
          {/* <Menu>
            <MenuButton
              as={Button}
              size="sm"
              rightIcon={<FiChevronDown />}
              borderRadius="lg"
              bg="white"
              border="1px solid #DFE1E6"
              _hover={{ bg: "#EDF2F7" }}
              width="150px"
            >
              Actions
            </MenuButton>
            <MenuList bg="white" border="1px solid #DFE1E6" minWidth="150px" boxShadow="sm">
              <MenuItem
                _hover={{
                  bg: '#EDEFF2',
                  color: 'black',
                  fontWeight: '500',
                  borderLeft: '4px solid #0052CC',
                  pl: 2,
                }}
                onClick={() => console.log('Create Design clicked')}
              >
                Create Design
              </MenuItem>
              <MenuItem
                _hover={{
                  bg: '#EDEFF2',
                  color: 'black',
                  fontWeight: '500',
                  borderLeft: '4px solid #0052CC',
                  pl: 2,
                }}
                onClick={() => console.log('Search Design clicked')}
              >
                Search Design
              </MenuItem>
            </MenuList>
          </Menu> */}

          <IconButton
            size="sm"
            icon={<FiX color="red" />}
            bg="white"
            border="1px solid #DFE1E6"
            _hover={{ bg: "#F4F5F7" }}
            onClick={onClose}
            aria-label="Close"
          />
        </HStack>

      </Flex>
    </Box>
  );
};

export default ModalHeader;